import { IShippingCreditCardRequest } from "@/apps/credit-line/types/requests";
import { LatestShipmentAddressModel } from "../types";
import { ICreditLineDetails } from "@/apps/credit-line/models/CreditLineDetails";
import { SHIPMENT_FLOW_TYPE } from "@/apps/credit-line/types/shipmentsType";
import { ReportLostOrDamagedCard } from "@/apps/credit-line/types/cards";

export const prepareShipmentPayload = (
  summary: ICreditLineDetails | null,
  latestShipmentAddress: LatestShipmentAddressModel,
  reportCardOptions: ReportLostOrDamagedCard,
  deviceTag: string
): IShippingCreditCardRequest => {
  return {
    deviceTag: deviceTag || "",
    firstName: latestShipmentAddress.cardUser?.firstName || "",
    lastName: latestShipmentAddress.cardUser?.lastName || "",
    birthday: latestShipmentAddress.cardUser?.birthday || "",
    email: latestShipmentAddress.cardUser?.email || "",
    gender: latestShipmentAddress.cardUser?.gender || "",
    taxIdentificationValue:
      latestShipmentAddress.cardUser?.taxIdentificationType || "",
    identificationValue:
      latestShipmentAddress.cardUser?.identificationValue || "",
    phone: latestShipmentAddress.receiverPhone || "",
    streetName: latestShipmentAddress.address?.street_name || "",
    streetNumber: latestShipmentAddress.address?.street_number || "",
    floor: latestShipmentAddress.address?.floor || "",
    apartment: latestShipmentAddress.address?.apartment || "",
    city: latestShipmentAddress.address?.city || "",
    zip: latestShipmentAddress.address?.zip_code || "",
    region: latestShipmentAddress.address?.region || "",
    neighborhood: latestShipmentAddress.address?.neighborhood || "",
    additionalInfo: "N/A",
    country: summary?.country || "",
    isZipCodeUserProvided: Boolean(latestShipmentAddress.address?.zip_code),
    source: "app",
    isProposedAddressSelected: false,
    shippingAttemptId: "NEW" + summary?.creditLineId + Date.now(),
    isGoogleAutocompleteShown: false,
    shippingType: SHIPMENT_FLOW_TYPE.RENEW_SHIPMENT,
    reportCardOption: reportCardOptions.lastFour
      ? {
          reason: reportCardOptions?.reason || "",
          lastFour: reportCardOptions?.lastFour || 0,
          details: reportCardOptions?.details || "",
        }
      : null,
  };
};
